import { render, staticRenderFns } from "./PromoTableItem.vue?vue&type=template&id=755ffc8e&scoped=true"
import script from "./PromoTableItem.vue?vue&type=script&lang=js"
export * from "./PromoTableItem.vue?vue&type=script&lang=js"
import style0 from "./PromoTableItem.vue?vue&type=style&index=0&id=755ffc8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "755ffc8e",
  null
  
)

export default component.exports